import React from 'react';
import { Box, Container } from '@mui/material';
import BrandSpace from './brandSpace';
import SocialConnect from './socialConnect';
import Company from './company';
import Legal from './legal';
import Copyrights from './copyrights';
import * as styles from './styles';

function ThinBars() {
    return (
        <Box aria-hidden="true" sx={styles.thinBars.wrapper}>
            <Box sx={styles.thinBars.bar1} />
            <Box sx={styles.thinBars.bar2} />
            <Box sx={styles.thinBars.bar3} />
        </Box>
    );
}

function Footer() {
    return (
        <Box component="footer" sx={styles.footer}>
            <ThinBars />

            <Container maxWidth="xl">
                <Box sx={styles.grid}>
                    <BrandSpace />
                    <SocialConnect />
                    <Box sx={styles.linkColumns}>
                        <Company />
                        <Legal />
                    </Box>
                </Box>

                <Copyrights />
            </Container>
        </Box>
    );
}

export default Footer;
